import { render, staticRenderFns } from "./Fourth_mobile.vue?vue&type=template&id=ef33f0ca&scoped=true&"
import script from "./Fourth_mobile.vue?vue&type=script&lang=js&"
export * from "./Fourth_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Fourth_mobile.vue?vue&type=style&index=0&id=ef33f0ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef33f0ca",
  null
  
)

export default component.exports